module.exports = __webpack_public_path__ + "img/solution-scene-rh.0654bcb8.png";